import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { unwrap } from '../utils/api';
import { withCheck } from '../components/Icon';

export default function SaveFonts() {
  const nav = useNavigate();
  const [file, setFile] = useState(null);
  const [name, setName] = useState('');
  const [weight, setWeight] = useState('400');
  const [busy, setBusy] = useState(false);

  const [bulkFiles, setBulkFiles] = useState([]);
  const [bulkBusy, setBulkBusy] = useState(false);
  const [bulkMsg, setBulkMsg] = useState('');

  async function upload() {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      fd.append('name', name || file.name.replace(/\.[^.]+$/, ''));
      fd.append('weight', weight);
      await api.post('/files/SaveFont', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      nav('/pages/fontsList');
    } finally { setBusy(false); }
  }

  async function uploadBulk() {
    if (!bulkFiles.length) return;
    setBulkBusy(true);
    setBulkMsg('');
    try {
      const fd = new FormData();
      for (const f of bulkFiles) fd.append('files', f);
      const r = await api.post('/files/SaveFontsBulk', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      const result = unwrap(r);
      let msg = `✓ Uploaded ${result.created} font${result.created === 1 ? '' : 's'}.`;
      if (result.skipped > 0) msg += ` Skipped ${result.skipped} (already exist): ${result.skippedNames.slice(0, 5).join(', ')}${result.skippedNames.length > 5 ? '…' : ''}`;
      setBulkMsg(msg);
      setBulkFiles([]);
    } catch (e) {
      setBulkMsg('Upload failed: ' + (e?.response?.data?.body || e.message));
    } finally { setBulkBusy(false); }
  }

  return (
    <>
      <h1>Upload Font</h1>
      <div className="card" style={{ maxWidth: 520 }}>
        <h3 style={{ marginTop: 0 }}>Single font</h3>
        <div className="prop"><label>TTF / OTF file</label><input type="file" accept=".ttf,.otf" onChange={e => setFile(e.target.files[0])} /></div>
        <div className="prop"><label>Font name</label><input value={name} onChange={e => setName(e.target.value)} placeholder="e.g. Fb Keisar" /></div>
        <div className="prop"><label>Weight</label>
          <select value={weight} onChange={e => setWeight(e.target.value)}>
            {['100', '200', '300', '400', '500', '600', '700', '800', '900'].map(w => <option key={w}>{w}</option>)}
          </select>
        </div>
        <button className="btn" onClick={upload} disabled={!file || busy}>{busy ? 'Uploading…' : 'Upload'}</button>
      </div>

      <div className="card" style={{ maxWidth: 520, marginTop: 24 }}>
        <h3 style={{ marginTop: 0 }}>Bulk upload</h3>
        <p style={{ fontSize: 13, color: '#666', marginTop: 0 }}>
          Select many .ttf/.otf files at once. Each font's name will be its filename (without the extension). Weight defaults to 400. Fonts with names that already exist are skipped.
        </p>
        <div className="prop">
          <label>Select files (or pick a folder)</label>
          <input
            type="file"
            accept=".ttf,.otf"
            multiple
            onChange={e => setBulkFiles(Array.from(e.target.files || []))}
          />
        </div>
        {bulkFiles.length > 0 && (
          <p style={{ fontSize: 13, color: '#444', margin: '8px 0' }}>
            {bulkFiles.length} file{bulkFiles.length === 1 ? '' : 's'} selected.
          </p>
        )}
        <button className="btn" onClick={uploadBulk} disabled={!bulkFiles.length || bulkBusy}>
          {bulkBusy ? `Uploading ${bulkFiles.length} fonts…` : `Upload ${bulkFiles.length || ''} fonts`}
        </button>
        {bulkMsg && (
          <p style={{ fontSize: 13, color: bulkMsg.startsWith('✓') ? '#198754' : '#dc3545', marginTop: 10 }}>
            {withCheck(bulkMsg)}
          </p>
        )}
      </div>
    </>
  );
}
